module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/feature-segment-06c8868f279d773026f7271b9fbe0754.gif";